import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";
import FooterLogo from "../../images/Credissuer-footer-logo.svg";
import { tenant } from "../../tenant";
import { PublicPortalFooterSkeleton } from "./PublicPortalSkeleton";

const FooterLinks = ({ title, links }) => (
  <div>
    <h3 className="mb-2 text-base font-semibold">
      {title}
    </h3>
    <div className="mb-5 h-1 w-10 rounded bg-cfPrimary" />
    <ul className="m-0 space-y-2 p-0">
      {links.map((link) => (
        <li key={link.label}>
          <a
            className="flex items-center text-sm no-underline opacity-80 transition hover:no-underline hover:opacity-100"
            href={link.href}
          >
            <span className="mr-3 h-1 w-1 rounded-full bg-current opacity-60" />
            {link.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

const PublicPortalFooter = ({
  assets,
  brand,
  contact,
  footer,
  isLoading = false,
}) => {
  if (isLoading) {
    return <PublicPortalFooterSkeleton />;
  }

  return (
    <footer
    className="w-full bg-publicPortal-footer text-publicPortal-onBrand"
    style={{
      backgroundColor: assets?.footer_background_color,
      color: assets?.footer_text_color,
    }}
  >
    <div className="grid w-full gap-9 px-5 py-12 sm:px-8 md:grid-cols-2 lg:grid-cols-4 lg:px-12">
      <div>
        <div className="mb-5 flex items-center gap-3">
          <img
            className="h-12 w-auto max-w-[180px] object-contain"
            src={assets?.footer_logo || FooterLogo}
            alt={brand.name}
          />
          <div>
            <p className="m-0 font-bold">{brand.name}</p>
            <p className="m-0 text-xs opacity-70">{brand.subtitle}</p>
          </div>
        </div>
        <p className="mb-5 text-sm leading-6 opacity-80">
          {footer.description}
        </p>
        <address className="space-y-2 text-sm not-italic opacity-80">
          <p className="m-0">
            <span className="font-semibold">{contact.addressLabel}:</span>{" "}
            {contact.address}
          </p>
          <a
            className="block text-inherit no-underline hover:text-inherit hover:opacity-100"
            href={`tel:${String(contact.phone || "").replace(/\s/g, "")}`}
          >
            <span className="font-semibold">{contact.phoneLabel}:</span>{" "}
            {contact.phone}
          </a>
          <a
            className="block text-inherit no-underline hover:text-inherit hover:opacity-100"
            href={`mailto:${contact.email}`}
          >
            <span className="font-semibold">{contact.emailLabel}:</span>{" "}
            {contact.email}
          </a>
        </address>
      </div>

      <div className="lg:pl-8">
        <FooterLinks title={footer.linksTitle} links={footer.links} />
      </div>
      <FooterLinks
        title={footer.documentationTitle}
        links={footer.documentation}
      />

      <div>
        <h3 className="mb-2 text-base font-semibold">
          {footer.followTitle}
        </h3>
        <div className="mb-5 h-1 w-10 rounded bg-cfPrimary" />
        <p className="mb-5 text-sm leading-6 opacity-80">
          {footer.followDescription}
        </p>
        <div className="flex gap-3">
          {[
            {
              Icon: FaFacebookF,
              label: "Facebook",
            },
            {
              Icon: FaInstagram,
              label: "Instagram",
            },
            {
              Icon: FaTwitter,
              label: "Twitter",
            },
          ].map(({ Icon, label }) => (
            <button
              type="button"
              aria-label={label}
              className="flex h-9 w-9 items-center justify-center rounded-[8px] bg-publicPortal-social text-publicPortal-onBrand transition hover:bg-publicPortal-socialHover"
              key={label}
            >
              <Icon aria-hidden="true" size={16} />
            </button>
          ))}
        </div>
      </div>
    </div>

    <div className="border-t border-current border-opacity-20">
      <div className="flex w-full flex-wrap items-center justify-center gap-3 px-5 py-6 text-center text-xs opacity-80 sm:px-8">
        <span>{assets?.footer_text || footer.copyright}</span>
        {tenant.branding?.inicLogo ? (
          <img
            className="h-8 w-auto object-contain"
            src={tenant.branding.inicLogo}
            alt="INIC"
          />
        ) : null}
      </div>
    </div>
    </footer>
  );
};

export default PublicPortalFooter;
